import { fork } from 'redux-saga/effects';

import { signupSaga } from './sagas/signup';
import { signinSaga } from './sagas/signin';
import { signoutSaga } from './sagas/signout';
import { verifyEmailSaga } from './sagas/verifyEmail';
import { publishProfileSaga } from './sagas/publishProfile';

export const authSaga = function* () {
  yield fork(signupSaga);
  yield fork(signinSaga);
  yield fork(signoutSaga);
  yield fork(verifyEmailSaga);
  yield fork(publishProfileSaga);
};
